import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../utils/Hooks";
import { useNavigate } from "react-router-dom";
import { LoggedInView } from "../common/LoggedInView";
import Breadcrumbs from "../common/Breadcrumbs";
import ElogInput from "../common/form/ElogInput";
import { BreadcrumbLink } from "../../models/BreadcrumbLink";
import { Link, useParams } from "react-router-dom";
import {
    createOfflineReason,
    resetCreateOfflineReasonStatus,
} from "../../store/reducers/OfflineReasonsSlice";
import { RequestStatus } from "../../utils/Enums";
import {FormikProvider, useFormik, Form} from "formik";
import {createSMSSender} from "../../store/reducers/SMSSendersSlice";

interface NewOfflineReasonScreenProps {}

export interface NewOfflineReasonFormProps {
    name: string;
}

export const NewOfflineReasonScreen: React.FC<NewOfflineReasonScreenProps> = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const offlineReasonsState = useAppSelector(
        (state) => state.offlineReasons
    );

    const requestStatus: RequestStatus =
        offlineReasonsState.createOfflineReasonStatus;

    const breadcrumbLinks: BreadcrumbLink[] = [
        { text: "Miks väljas põhjused", url: "/offline-reasons" },
        { text: "Lisa uus miks väljas põhjus", url: "/offline-reasons/new" },
    ];

    useEffect(() => {
        if (requestStatus === RequestStatus.Success) {
            dispatch(resetCreateOfflineReasonStatus());
            navigate(breadcrumbLinks[0].url);
        }
    }, [requestStatus]);

    // @ts-ignore
    const formik = useFormik({
        initialValues: {
        },
        onSubmit: (values: any) => {
            dispatch(createOfflineReason(values));
        },
        enableReinitialize: true
    });

    const {values, setFieldValue, handleSubmit} = formik;

    return (
        <LoggedInView fullWidth={false}>
            <Breadcrumbs links={breadcrumbLinks} />
            {requestStatus === RequestStatus.Failed &&
            offlineReasonsState.errors.length > 0 && (
                <div className="message msg-error">
                    <div>
                        <h2>Viga:</h2>
                        {offlineReasonsState.errors.map(
                            (error, index) => (
                                <span key={index}>
                                        {error}
                                    <br />
                                    </span>
                            )
                        )}
                    </div>
                </div>
            )}
            <FormikProvider value={formik}>
                <Form onSubmit={handleSubmit}>
                    <div className="form">
                        <h2>
                            <span>Offline põhjuse andmed</span>
                        </h2>
                        <table className="form">
                            <tbody>
                            <ElogInput
                                label="Nimi"
                                name="name"
                                mandatory={true}
                            />
                            </tbody>
                        </table>
                    </div>
                    <div className="action clear">
                        <p>
                            <button type="submit">
                                    <span>
                                        <strong>Sisesta</strong>
                                    </span>
                            </button>
                            <Link to="/offline-reasons">Tühista</Link>
                        </p>
                    </div>
                </Form>
            </FormikProvider>
        </LoggedInView>
    );
};